import { FC, PropsWithChildren } from 'react'
import { Button as MuiButton, ButtonProps } from '@mui/material'
import theme from 'theme'
import styled from '@emotion/styled/macro'

const Button = styled(MuiButton)`
  background: transparent;
  box-sizing: border-box;
  color: ${theme.colors.rawSienneCore};
  border-radius: ${theme.attributes.borderRadius.circle};
  text-transform: capitalize;
  font-size: ${theme.typography.fontSize.large};
  width: ${theme.iconSize.large}px;
  height: ${theme.iconSize.large}px;
  min-width: unset;

  :hover {
    color: #dbdbdb;
  }
`

type Props = ButtonProps

const CircleButton: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  return <Button {...props}>{children}</Button>
}

export default CircleButton
